import { CarFront, Gavel, ReceiptText } from 'lucide-react'
import { motion, useReducedMotion } from 'motion/react'

/*
  Base: "Feature Problem Cards" (feature-07) de hirael (21st.dev) — MIT,
  Mohammad Shehadeh — instalado e adaptado: os três cartões ganharam a cópia da
  consulta e o orbe passou a usar o vermelho da marca no lugar do tom neutro.
*/

const FEATURES = [
  {
    icon: CarFront,
    title: 'Dados do veículo',
    description:
      'Marca, modelo, cor, ano de fabricação e ano modelo, para confirmar que o anúncio bate com o documento.',
  },
  {
    icon: ReceiptText,
    title: 'Débitos e restrições',
    description:
      'Quanto o veículo deve e quais restrições impedem a transferência para o seu nome.',
  },
  {
    icon: Gavel,
    title: 'Leilão e sinistro',
    description:
      'Se o carro já passou por leilão, quem foi o leiloeiro e se existe indício de sinistro.',
  },
]

export function FeatureCards() {
  const reduce = useReducedMotion()

  return (
    <section
      id="o-que-voce-descobre"
      className="flex w-full flex-col justify-center gap-12 bg-muted px-4 py-16 md:py-24"
    >
      <div className="mx-auto flex max-w-3xl flex-col gap-4 text-center">
        <h2 className="text-3xl font-bold tracking-tight text-foreground md:text-4xl">
          O que você descobre antes de pagar
        </h2>
        <p className="text-base leading-relaxed text-muted-foreground">
          A consulta grátis já mostra o veículo. O relatório abre o que decide a
          compra.
        </p>
      </div>

      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-4 md:grid-cols-3">
        {FEATURES.map((feature, index) => (
          <motion.div
            key={feature.title}
            className="group relative flex flex-col items-center gap-6 overflow-hidden rounded-xl border border-border bg-background px-8 pb-8 pt-10 text-center"
            initial={reduce ? false : { opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.6, delay: index * 0.1, ease: 'easeOut' }}
          >
            <div className="relative mx-auto flex size-24 items-center justify-center rounded-full border border-brand-soft bg-brand-soft outline outline-brand-soft outline-offset-4">
              <feature.icon className="relative z-20 size-10 text-brand" aria-hidden />
            </div>
            <div className="flex flex-col gap-1.5">
              <h3 className="text-lg font-semibold text-foreground">{feature.title}</h3>
              <p className="text-sm leading-relaxed text-muted-foreground">
                {feature.description}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  )
}
